
export const sanitizeNumberInput = (event:  { key: string; preventDefault: () => any; }) => {
  const keys = ["e", "E", "+", "-", ".", ","];
  if (keys.includes(event.key)) {
    event.preventDefault();
  }
}